import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Btns,
  ButtonL,
  Content,
  ImgWrap,
  Section,
  TextDiv,
} from "../../styles/Common";
import { ReactComponent as IcoCopy } from "../../styles/images/ico_copy_dark.svg";
import { styled } from "styled-components";
import { getToken } from "../hooks/authFunc";
import { useDispatch, useSelector } from "react-redux";
import { amoActions } from "../../store/slices/amoSlice";
import { Modal } from "../modal/Modal";
import useDidMountEffect from "../hooks/useDidMountEffect";
import CopyToClipboard from "react-copy-to-clipboard";
const ToPointComponent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [confirmAmo, setConfirmAmo] = useState("");
  const [changedMup, setChangedMup] = useState("");
  const [notHistoryModal, setNotHistoryModal] = useState(false);
  const [notConfirmHistoryModal, setNotConfirmHistoryModal] = useState(false);
  const accessToken = getToken();

  const temporaryWalletAddr = useSelector(
    (state) => state.amo.temporaryWalletAddr
  );
  const swapConfirmResult = useSelector((state) => state.amo.swapConfirmResult);

  const getData = () => {
    //발급으로부터 24시간 유효한 지갑 주소.
    // 유저가 다시 페이지 진입 시, 유효한 임시입금주소가 있다면 재발급 x, 없다면 재발급
    const params = {};
    dispatch(amoActions.fetchTemporaryWalletAddr({ params, accessToken }));
  };

  const handleSwapConfirm = () => {
    const params = {
      wallet: temporaryWalletAddr.wallet,
    };
    dispatch(amoActions.fetchSwapConfirm({ params, accessToken }));
  };
  useEffect(() => {
    getData();
  }, []);

  useDidMountEffect(() => {
    if (swapConfirmResult != {} && swapConfirmResult.info?.tx == null) {
      setNotConfirmHistoryModal(true);
    } else if (swapConfirmResult.info.tx) {
      setConfirmAmo(swapConfirmResult.info.amo);
      setChangedMup(swapConfirmResult.info.mup);
    }
  }, [swapConfirmResult]);
  return (
    <Section className="nonePaddingTop">
      {/* //todo mas로 받아와서 openModal로 처리하기*/}
      {notHistoryModal && (
        <Modal setOpenModal={setNotHistoryModal}>
          <p>
            교환된 내역이 존재 하지 않습니다. <br />
            입금을 한후 교환 뮤포인트가 확인되면 <br />
            다시 이용해 주세요.
          </p>
        </Modal>
      )}
      {/* //todo mas로 받아와서 openModal로 처리하기*/}
      {notConfirmHistoryModal && (
        <Modal setOpenModal={setNotConfirmHistoryModal}>
          <p>
            입금한 AMO 코인을 찾을수 없습니다. <br />
            입금 후 확인하기까지 약간의 시간이 소요 될 수 있습니다. <br />
            잠시 후 다시 시도해주세요!
          </p>
        </Modal>
      )}
      <div>
        <SwapContent>
          <h4>일회용 아모코인 입금주소</h4>
          <InputWrap>
            <input
              type="text"
              value={temporaryWalletAddr.wallet || ""}
              disabled
            />

            <CopyToClipboard
              text={temporaryWalletAddr.wallet}
              className="pointer"
              onCopy={() =>
                console.log(
                  "클립보드에 복사되었습니다.",
                  temporaryWalletAddr.wallet
                )
              }
            >
              <IcoCopy />
            </CopyToClipboard>
          </InputWrap>
          <Desc>
            뮤 포인트로 교환할 AMO 코인을 일회용 입금주소로 입금해주세요.
          </Desc>
          <UlWrap>
            <p>교환하기전 아래 정보를 반드시 확인해주세요!</p>
            <ul>
              <li>입금 주소는 일회용 주소입니다.</li>
              <li>
                입금된 AMO 코인은 뮤포인트로 <b>바로</b> 교환됩니다.
              </li>
              <li>
                입금된 즉시 AMO 시세와 연동하여 뮤포인트로 교환되며
                <br /> 아래 새로고침 버튼을 통해 교환된 수량을 확인하실 수
                있습니다.
                <br />
                교환수수료 :{"  5"} % (뮤포인트 차감)
              </li>
            </ul>
            <p>
              입금이 진행되는 동안 AMO 시세 변화가 있을수 있습니다. 이러한 시세
              변화에 대해 어떠한 책임도 지지 않습니다.
            </p>
          </UlWrap>
        </SwapContent>

        <Content>
          <SwapWrap>
            <div>
              <Title>
                <h4>입금된 AMO 코인</h4>
                <button
                  onClick={() => {
                    handleSwapConfirm();
                  }}
                >
                  새로고침
                </button>
              </Title>
              <InputWrap>
                <input type="number" disabled value={confirmAmo} />
                <p>AMO</p>
              </InputWrap>
              <Desc>
                일회용 입금주소로 아모를 입금하고 새로고침 버튼을 눌러주세요.
                <br />
                입금된 수량이 표시되고 뮤포인트 수량도 확인하실수 있습니다.
                <br />
                <span className="colRed">최소 입금수량</span> 1000 AMO / 일 한도
                10,000 월 한도 100,000
              </Desc>
            </div>
            <div className="amo">
              <Title>
                <h4>교환 뮤포인트</h4>
              </Title>
              <InputWrap>
                <input type="number" disabled value={changedMup} />
                <p>MUP</p>
              </InputWrap>
            </div>
          </SwapWrap>
        </Content>
      </div>

      <Btns>
        <ButtonL
          onClick={() => {
            //교환성공내역 조회하고 없으면 모달, 있으면 이동
            swapConfirmResult.info.tx
              ? navigate("/amo/change/result", {
                  state: {
                    type: "toPoint",

                    wallet: temporaryWalletAddr.wallet,
                  },
                })
              : setNotHistoryModal(true);
          }}
        >
          교환 완료 확인
        </ButtonL>
      </Btns>
    </Section>
  );
};

export default ToPointComponent;
const SwapWrap = styled.div`
  & > div {
    margin-top: 3rem;
  }
`;
const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  h4 {
    font-weight: 700;
    line-height: 1.6rem; /* 100% */
  }
  button {
    width: 6.4rem;
    height: 2rem;
    flex-shrink: 0;
    border-radius: 1rem;
    background-color: ${({ theme }) => theme.color.purple_secondary};
    color: ${({ theme }) => theme.color.white};
    font-size: 1.2rem;
    line-height: 1.2rem; /* 100% */
  }
`;
const Desc = styled.p`
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 1.6rem;
  color: ${({ theme }) => theme.color.purple_secondary};
  margin-top: 1rem;
  letter-spacing: -0.36px;
  .colRed {
    color: ${({ theme }) => theme.color.pink};
  }
`;
const InputWrap = styled.div`
  border-bottom: 1px solid #000;
  display: flex;
  justify-content: space-between;
  padding: 1rem 0;
  margin-top: 0.5rem;
  input {
    width: calc(100% - 5rem);
    color: ${({ theme }) => theme.color.black};
    font-size: 1.6rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.6rem; /* 100% */
    background-color: transparent;
    &:focus {
      outline: none;
    }
    &:disabled {
      color: ${({ theme }) => theme.color.input_text_gray};
      font-weight: 500;
    }
  }
  p {
    text-align: right;
    color: ${({ theme }) => theme.color.input_text_gray};
    font-weight: 400;
  }
`;
const SwapContent = styled(Content)`
  padding-top: 3rem;
  padding-bottom: 3rem;
  background: ${({ theme }) => theme.color.purple_bg_dark};
  h4 {
    font-size: 1.6rem;
    line-height: 1.6rem; /* 142.857% */
    font-weight: 700;
  }
  ul {
    padding: 1rem 0;
    li {
      color: ${({ theme }) => theme.color.purple_dark};
      font-size: 1.2rem;
      line-height: 1.8rem; /* 150% */
      font-weight: 500;
      letter-spacing: -0.36px;
      position: relative;
      margin-left: 0.8rem;
      &::before {
        content: "· ";
        position: absolute;
        left: -0.8rem;
      }
    }
  }
`;
const UlWrap = styled.div`
  margin-top: 2rem;
  p {
    color: ${({ theme }) => theme.color.black};
    font-size: 1.2rem;
    line-height: 1.8rem; /* 150% */
    letter-spacing: -0.36px;
  }
`;
